import React from 'react';
import SandboxedContent from '../../../../../SandboxedContent/SandboxedContent';

function ScheduleItemFullDescription(props) {
    const { session } = props,
        { full_description } = session;

    if (!full_description) return null;

    return (
        <div className="content">
            <SandboxedContent content={session.full_description} fitHeightToContents noInnerPadding />
        </div>
    );
}

export default ScheduleItemFullDescription;
